var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "mask-side-section-container",
    { attrs: { title: _vm.$t("Resize") } },
    [
      _c(
        "v-flex",
        { staticClass: "mb-2", attrs: { shrink: "" } },
        [
          _c(
            "input-field",
            {
              attrs: {
                value: _vm.maskType,
                label: "Mask Type",
                inputType: "other",
                size: "large"
              }
            },
            [
              _c(
                "div",
                [
                  _c("treeselect", {
                    staticClass: "form-input-select",
                    attrs: {
                      options: _vm.maskTypes,
                      normalizer: _vm.listElementNormalizer,
                      valueFormat: "object",
                      clearable: false,
                      disableFuzzyMatching: ""
                    },
                    model: {
                      value: _vm.maskType,
                      callback: function($$v) {
                        _vm.maskType = $$v
                      },
                      expression: "maskType"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { margin: "4px 20px" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "accent",
                  attrs: {
                    small: "",
                    block: "",
                    round: "",
                    disabled: _vm.maskType === _vm.originalMaskType
                  },
                  on: { click: _vm.tryResize }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("photo_size_select_small")
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Apply")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.confirmationDialogIsOpen,
          title: _vm.$t("RemovingDuctEntries"),
          content:
            _vm.$t("CheckMaskResize") + "\n\n" + _vm.$t("ContinueConfirmation"),
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes")
        },
        on: {
          mainAction: function($event) {
            _vm.confirmationDialogIsOpen = false
          },
          secondaryAction: _vm.resizeWithDuctEntryRemoval
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d45faa7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d45faa7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Masks/Masks/MaskResize.vue
// module id = null
// module chunks = 